<template>
    <modal
        name="sign-up-modal"
        height="auto"
        width="30%"
        :scrollable="true"
        :adaptive="true"
        class="sign-up-modal position-relative"
        @before-open="beforeOpen">
        <div class="icon-close-modal" @click="$modal.hide('sign-up-modal')">
            <button class="btn btn-orange">
                <i class="fas fa-times"></i>
            </button>
        </div>

        <SignUpFormModal v-if="!success && !error && !duplicated" :back-to-sign-up="backToSignUp"/>
        <ModalThanks  v-if="success && !error  && !duplicated" :back-to-sign-up="backToSignUp"/>
        <ModalDuplicateEmail  v-if="!success && duplicated" :back-to-sign-up="backToSignUp"/>
        <ModalError  v-if="!success && error" :back-to-sign-up="backToSignUp"/>
    </modal>
</template>

<script>
import SignUpFormModal from "@/components/SignUpFormModal"
import ModalThanks from "@/components/ModalThanks"
import ModalDuplicateEmail from "@/components/ModalDuplicateEmail"
import ModalError from "@/components/ModalError"

export default {
    name: "SignUpModal",
    components: {
        SignUpFormModal,
        ModalThanks,
        ModalError,
        ModalDuplicateEmail
    },
    data() {
        return {
            success: false,
            error: false,
            duplicated: false,
            backToSignUp: false
        }
    },

    methods:{
        beforeOpen(event) {
            this.success = event.params ? event.params.success : false;
            this.error = event.params ? event.params.error : false;
            this.duplicated = event.params ? event.params.duplicated : false;
            this.backToSignUp = event.params ? event.params.backToSignUp : false;
        }
    }
}
</script>
<style lang="scss" scoped>
.sign-up-modal {
    overflow: auto;
    position: relative;
    border-radius: 15px;

    .icon-close-modal {
        position: absolute;
        top: -15px;
        right: -15px;
        z-index:1;

        button {
            border-radius: 50%;
            padding: 0;
            width: 50px;
            height: 50px;

            i {
                font-size: $medium-font-size;
            }
        }
    }
}
</style>
<style lang="scss">
.v {
    &--modal-overlay {
        .v {
            &--modal-box {
                overflow: initial!important;
                max-width:600px;
                width: 50%!important;
                margin: 0 auto;
                left: 0!important;
            }
        }
    }
}
// Medium devices (tablets, 768px)
@media screen and (max-width:768px) {
    .v {
        &--modal-overlay {
            .v {
                &--modal-box {
                    min-width:auto;
                    max-width: 70%;
                    width: 100%!important;
                    top:80px!important;
                }
            }
        }
    }

    .sign-up-modal {
        .icon-close-modal {
            top:-10px;
            right: -8px;
        }
    }
}
// Medium devices (mobile, 480px)
@media screen and (max-width:480px) {
    .v {
        &--modal-overlay {
            .v {
                &--modal-box {
                    max-width: 90%;
                    top:30px!important;

                    .content-fancy {
                        height: 400px;
                        overflow: scroll;

                        .btn-orange {
                            width:100%;
                        }
                    }
                }
            }

            li {
                font-size:$mobile-extra-small-font-size;
                margin-bottom: 10px;
            }
        }
    }
}
</style>